module.exports = __webpack_public_path__ + "static/media/bank-bank-cta.3ff8e555.png";